
<form
  :action="uploadFile"
  enctype="multipart/form-data"
  class="position-relative"
  data-component="FilesSender"
  :data-files-count="filesCount"
>
  <!-- -->
  <slot name="slotTeleversement" :filesCount="filesCount" :addFile="mixinAddFile_addFile"> </slot>
  <!--  -->
</form>
